import { __extends } from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import TextTooltipOnHover from '../../../Popover/TextTooltipOnHover';
import { BiDataHook } from '../../../biLogger';
import s from 'wix-rich-content-common/dist/statics/styles/inline-toolbar-button.scss';
// Fork of https://github.com/wix-incubator/rich-content/blob/master/packages/common/src/Components/InlineToolbarButton.jsx
// Differences:
// - Changed handleClick to pass e
// - Use our own tooltips and disable wix-rich-content ones
var InlineToolbarButton = /** @class */ (function (_super) {
    __extends(InlineToolbarButton, _super);
    function InlineToolbarButton(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            e.preventDefault();
            _this.props.onClick && _this.props.onClick(e);
        };
        _this.preventBubblingUp = function (e) { return e.preventDefault(); };
        var _e = (props.theme || {}).buttonStyles, buttonStyles = _e === void 0 ? {} : _e;
        _this.styles = {
            button: classNames(s['inlineToolbarButton'], (_a = {},
                _a[buttonStyles.inlineToolbarButton] = !!buttonStyles.inlineToolbarButton,
                _a[buttonStyles.pluginToolbarButton] = !!buttonStyles.pluginToolbarButton,
                _a)),
            buttonWrapper: classNames(s['inlineToolbarButton_wrapper'], (_b = {},
                _b[buttonStyles.inlineToolbarButton_wrapper] = !!buttonStyles.inlineToolbarButton_wrapper,
                _b[buttonStyles.pluginToolbarButton_wrapper] = !!buttonStyles.pluginToolbarButton_wrapper,
                _b)),
            icon: classNames(s['inlineToolbarButton_icon'], (_c = {},
                _c[buttonStyles.inlineToolbarButton_icon] = !!buttonStyles.inlineToolbarButton_icon,
                _c[buttonStyles.pluginToolbarButton_icon] = !!buttonStyles.pluginToolbarButton_icon,
                _c)),
            active: classNames(s['inlineToolbarButton_active'], (_d = {},
                _d[buttonStyles.inlineToolbarButton_active] = !!buttonStyles.inlineToolbarButton_active,
                _d[buttonStyles.pluginToolbarButton_active] = !!buttonStyles.pluginToolbarButton_active,
                _d)),
        };
        return _this;
    }
    InlineToolbarButton.prototype.render = function () {
        var _a;
        var _b = this.props, t = _b.t, isActive = _b.isActive, isMobile = _b.isMobile, tooltipTextKey = _b.tooltipTextKey, tabIndex = _b.tabIndex, Icon = _b.icon;
        var styles = this.styles;
        var tooltipText = tooltipTextKey
            ? t(tooltipTextKey)
            : this.props.tooltipText;
        var showTooltip = !isMobile && !isEmpty(tooltipText);
        var iconClassNames = classNames(styles.icon, (_a = {},
            _a[styles.active] = isActive,
            _a));
        return (React.createElement("div", { className: styles.buttonWrapper, onMouseDown: this.preventBubblingUp },
            React.createElement("button", { tabIndex: tabIndex, "aria-label": tooltipText, "aria-pressed": isActive, "data-hook": BiDataHook.CODEBLOCK_BUTTON, onClick: this.handleClick, className: styles.button },
                React.createElement("div", { className: iconClassNames }, showTooltip ? (React.createElement(TextTooltipOnHover, { tooltipText: tooltipText },
                    React.createElement(Icon, null))) : (React.createElement(Icon, null))))));
    };
    return InlineToolbarButton;
}(React.Component));
export default withTranslation()(InlineToolbarButton);
//# sourceMappingURL=InlineToolbarButton.js.map